import MultiLanguageString from "../languages/MultiLanguageString";
import DataController from "../DataController";

export default class Permission extends DataController{
    
    @DataController.dataProperty()
    private name: string;
    
    @DataController.dataProperty(async (x) => await x.asList())
    private description: MultiLanguageString;
    
    constructor(name: string, description: MultiLanguageString) {
        super();
        this.name = name;
        this.description = description;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public getName(): string{
        return this.name;
    }

    public setDescription(description: MultiLanguageString): void {
        this.description = description;
    }

    public getDescription(): MultiLanguageString{
        return this.description;
    }
    
    public clone(): Permission {
        return new Permission(
            this.name,
            this.description.clone(),
        )
    }
}